import { Loading } from '@/components/Loading';
import { useAuthStore } from '@/stores/useAuthStore';
import { handleError } from '@/utils/handleError';
import { useEffect, useRef } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

export const SocialLoginCallback = () => {
  const { isAuth, socialLoginCallback } = useAuthStore();
  const { provider } = useParams<{ provider: string }>();
  const [searchParams] = useSearchParams();
  const callbackExecutedRef = useRef(false);

  const code = searchParams.get('code');

  useEffect(() => {
    const handleCallback = async () => {
      if (!provider || !code || callbackExecutedRef.current) {
        if (!provider || !code) {
          handleError(new Error('Missing provider parameter'));
        }
        return;
      }

      callbackExecutedRef.current = true;

      try {
        // Pass all possible search params to ensure we capture them
        await socialLoginCallback(provider, code);
        localStorage.setItem('from_social_login', 'true');
      } catch (error) {
        handleError(error);
      }
    };

    handleCallback();
  }, [provider, isAuth, socialLoginCallback, code]);

  return <Loading />;
};
